<div class="backdrop-box-details booking-travler-pop">
<div class="modal fade show traveler-popup-div" bsModal tabindex="-1" role="dialog" aria-labelledby="dialog-nested-name1" style="display: block;">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title flight-detail-pop-title" id="staticBackdropLabel">
          <div class="back-pop-btn" (click)="onBackButtonClick()">
            <i class="fa-solid fa-angle-left me-0"></i>
          </div>
          <i class="fa-solid fa-plane"></i>
          {{'Seat Selection' | translate}}
          <div class="skip">
            <a (click)="confirmSelection()">{{'Skip Seat Selection' | translate}} <i class="fa-solid fa-arrow-right-long"></i></a>
          </div>
          </h5>
         <div class="skip-seat-select-btn">
            <a (click)="confirmSelection()" class="skip-selection">{{'Skip Seat Selection' | translate}} <i class="fa-solid fa-angle-right"></i></a>
            <button type="button" class="btn-close btnbtn" (click)="onClose()" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body flight-trip-in-body">
        <div class="select-seat-lists">
          <ul>
              <li>
                  {{'Get peace of mind by selecting your preferred seat now' | translate}}
              </li>
              <li>
                  {{'Request a seat next to friends and family' | translate}}
              </li>
              <li>
                  {{'Select from mostly window and aisle seats' | translate}}
              </li>
          </ul>
        </div>
        <div class="airline-flight-lists mt-2">
          <ul>
            <li *ngFor="let flight of flights" [class.active]="flight === selectedFlight" (click)="selectFlight(flight)">
              <div class="airline-flight-numb">
                <div class="flight-numb-img">
                  <img [src]="flight.imageSrc" alt="">
                </div>
                <div class="airline-flight-number-detls">
                  <h5>{{ flight.flightNumber | translate}}</h5>
                  <p>{{ flight.route | translate}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="airline-dtls-seats-info">
          <span>{{'Air India Airbus Jet 321 120-180 STD SEATS' | translate}}</span>
          <ul class="mb-0">
              <li class="prefred-seats">
                  <span>
                  <i class="fa-solid fa-star"></i>
                  </span>
                  {{'Preferred Seat' | translate}}
              </li>
              <li class="avilalbe-sets">
                  <span></span>
                  {{'Available seat' | translate}}
              </li>
              <li class="unavilalbe-sets">
                  <span><i class="fa-solid fa-xmark"></i></span>
                  {{'Unavailable seat' | translate}}
              </li>
              <li class="selected-sets">
                  <span></span>
                  {{'Selected seat' | translate}}
              </li>
          </ul>
        </div>
        <div class="select-flight-seats-imag w-100 mt-3">
          <div class="travelers-names-based-seat">
            <ul class="ps-0 mb-0 mt-3">
                <li>
                    <div class="traveler-name-selected-sea active seat-selected">
                        <i class="fa-solid fa-circle-check"></i>
                        <div class="traveler-name--selected">
                            <h5>1. {{'Mr Abdelslam Aly' | translate}}</h5>
                            <p>{{'12F - (Window) - USD 4.20' | translate}}</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="traveler-name-selected-sea">
                        <i class="fa-solid fa-circle-check"></i>
                        <div class="traveler-name--selected">
                            <h5>2. {{'Somya Martand' | translate}}</h5>
                            <p>--</p>
                        </div>
                    </div>
                </li>
            </ul>
          </div>

          <div class="clear-selection-btn" onclick="clearSelection()" style="display: none;">
              <a>{{'Clear Selection' | translate}}</a>
          </div>

          <div class="airline-seats-fregment" id="airlineSeatsFragment" #airlineSeats>
            <div class="seatmap-selection">
              <!-- flight back wings -->
              <div class="flight-wings-right">
                <span></span>
              </div>
              <ul class="windows-row row">
                <li>F</li>
                <li class="seatmap-seats avail pref">
                  <div class="seat-price-tooltip">
                    <span>4F</span>
                    <p>Window Preferred Seat</p>
                    <h6>SAR 10.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats avail pref">
                  <div class="seat-price-tooltip">
                    <span>7F</span>
                    <p>Window Preferred Seat</p>
                    <h6>SAR 12.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats avail pref">
                  <div class="seat-price-tooltip">
                    <span>8F</span>
                    <p>Window Preferred Seat</p>
                    <h6>SAR 11.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-othercabin">
                  <i class="fa-solid fa-restroom"></i>
                </li>
                <li class="no-bg"></li>
                <li class="seatmap-othercabin">
                  <i class="fa-solid fa-utensils"></i>
                </li>
              </ul>
              <ul class="windows-row row">
                <li>E</li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats avail">
                  <div class="seat-price-tooltip">
                    <span>27E</span>
                    <p>Middel Standard Seat</p>
                    <h6>SAR 6.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats avail">
                  <div class="seat-price-tooltip">
                    <span>29E</span>
                    <p>Middel Standard Seat</p>
                    <h6>SAR 6.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
              </ul>
              <ul class="windows-row row">
                <li>D</li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
              </ul>
              <ul class="windows-row windows-numbs row">
                <li></li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>10</li>
                <li>11</li>
                <li>12</li>
                <li>13</li>
                <li>14</li>
                <li>15</li>
                <li>16</li>
                <li>17</li>
                <li>18</li>
                <li>19</li>
                <li>20</li>
                <li>21</li>
                <li>22</li>
                <li>23</li>
                <li>24</li>
                <li>25</li>
                <li>26</li>
                <li>27</li>
                <li>28</li>
                <li>29</li>
                <li>30</li>
                <li>31</li>
                <li>32</li>
                <li>33</li>
              </ul>
              <ul class="windows-row row">
                <li>C</li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
              </ul>
              <ul class="windows-row row">
                <li>B</li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats avail">
                  <div class="seat-price-tooltip">
                    <span>30B</span>
                    <p>Middel Standard Seat</p>
                    <h6>SAR 6.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats avail">
                  <div class="seat-price-tooltip">
                    <span>31B</span>
                    <p>Middel Standard Seat</p>
                    <h6>SAR 6.00</h6>
                  </div>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
              </ul>
              <ul class="windows-row row">
                <li>A</li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit-last">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit-last">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats">
                  <span class="seatmap-exit-last">{{'Exit' | translate}}</span>
                </li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="seatmap-seats"></li>
                <li class="no-bg"></li>
                <li class="seatmap-othercabin">
                  <i class="fa-solid fa-restroom"></i>
                </li>
                <li class="seatmap-othercabin">
                  <i class="fa-solid fa-utensils"></i>
                </li>
              </ul>
              <!-- flight back wings -->
              <div class="flight-wings-left">
                <span></span>
              </div>
            </div>
          </div>
          <!-- <img src="image/flight-seats.jpg" alt=""> -->
          <div class="rear-front-seat-btn">
            <a class="front-seat-btn" (click)="scrollSeats('left')"><i class="fa-solid fa-angles-left"></i> {{'Move to front seat' | translate}}</a>
            <a class="rear-seat-btn" (click)="scrollSeats('right')">{{'Move to rear seat' | translate}} <i class="fa-solid fa-angles-right"></i></a>
        </div>
        </div>
        <div class="selected-seats-pricing">
          <a (click)="toggleSeatDetails()" role="button" aria-controls="sealctedSeats">
            {{'Selected Seats Details' | translate}} <i class="fa-solid fa-chevron-down"></i>
          </a>
            <div class="mt-2" [class.collapse]="isSeatDetailsCollapsed" [class.show]="!isSeatDetailsCollapsed" id="sealctedSeats">
              <div class="card card-body border-0 p-0 scroll">
                  <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">{{'Travelers' | translate}}</th>
                          <th scope="col" class="flight-class-tab-nam">{{'Flight' | translate}} 532 <span>{{'(AMD-DEL)' | translate}}</span></th>
                          <th scope="col" class="flight-class-tab-nam">{{'Flight' | translate}} 101 <span>(DEL-JFK)</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1. {{'Mr Abdelslam Aly' | translate}}</th>
                          <td>11F ({{'Window' | translate}})</td>
                          <td>14E ({{'Window' | translate}})</td>
                        </tr>
                        <tr>
                          <th scope="row">2. {{'Somya Martand' | translate}}</th>
                          <td>12F ({{'Window' | translate}})</td>
                          <td>15E ({{'Window' | translate}})</td>
                        </tr>
                        <tr>
                          <th scope="row">{{'Sub total by flight' | translate}}</th>
                          <td class="seat-price-preferd">2 {{'Preferred Seat' | translate}} = <span>10.00 SAR</span></td>
                          <td class="seat-price-preferd">2 {{'Preferred Seat' | translate}} = <span>11.50 SAR</span></td>
                        </tr>
                      </tbody>
                    </table>
              </div>
            </div>
            <div class="final-seat-sub-total-price">
              <div class="pricing-listing-dtls">
                  <ul>
                      <li>
                          <span class="l-span" >{{'Subtotal Seats Price' | translate}}:</span>
                          <span class="r-span" >SAR 10.00</span>
                      </li>
                      <li>
                          <span class="l-span" >{{'Non-refundable Enhanced Seat Assignment (ESA) Fee' | translate}}: <mark data-toggle="tooltip" title="This optional service allows you to have our Seat Assignment Group request your preferred seat assignments on your behalf, as per your selections on this interactive seat map. Seat assignment requests remain subject to airline approval and cannot be guaranteed. This is a non-refundable agency fee, not an airline fee."><i class="fa-regular fa-circle-question"></i></mark></span>
                          <span class="r-span" >SAR 20.00</span>
                      </li>
                      <li>
                          <span class="l-span" >{{'Grand Total Seat Selection Price' | translate}}:</span>
                          <span class="r-span" >SAR 30.00</span>
                      </li>
                  </ul>
              </div>
              <div class="cofimr-seat-seleted">
                  <button (click)="confirmSelection()" data-bs-target="#bookTickets" data-bs-toggle="modal" data-bs-dismiss="modal">{{'Confirm My Seat Selection' | translate}}</button>
                  <span><a>{{'Clear All Selection' | translate}}</a> <span class="line-none" >|</span> <a>{{'Save Selection and Close' | translate}}</a></span>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
